<template>
  <div>
    <QueryFrame
      :add-text="handlePermission('workflowAdd')?'新建审批流':''"
      :count="count"
      :current="page"
      @addNew="addNew"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>审批流名称:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.name"></lk-input>
          </div>
          <div class="queryItem">
            <label>适用单据:</label>
            <lk-select class="item" filterable clearable v-model.trim='query.bizTypeList' multiple>
              <lk-option v-for="item in bizTypeList" :key="item.id" :value="item.businessType">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>适用门店:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>启用状态:</label>
            <lk-select v-model="query.status" class="item" clearable>
              <lk-option v-for="item in statusMap" :key="item[0]" :value="item[0]">{{item[1]}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import workflow from '../../services/workflow';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'WorkflowList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {
    hasAction() {
      return this.handlePermission('workflowInfo') && this.handlePermission('workflowEdit');
    },
  },
  data() {
    return {
      query: {
        name: null,
        bizTypeList: null,
        storeIdList: null,
        status: null,
      },
      bizTypeList: [], // 适用单据
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '审批流名称',
          key: 'name',
          minWidth: 116,
        },
        {
          title: '审批流版本',
          key: 'versionStr',
          minWidth: 116,
        },
        {
          title: '适用单据类型',
          key: 'bizTypeNameListStr',
          minWidth: 150,
          tooltip: true,
        },
        {
          title: '适用门店',
          key: 'storeIdNameListStr',
          minWidth: 150,
          tooltip: true,
        },
        {
          title: '创建时间',
          key: 'createTimeStr',
          minWidth: 116,
        },
        {
          title: '最后启用时间',
          key: 'lastEnableTimeStr',
          minWidth: 116,
        },
        {
          title: '状态',
          key: 'statusStr',
          minWidth: 116,
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            this.handlePermission('workflowInfo') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'workflowInfo',
                    params: {
                      id: row.code,
                    },
                  });
                },
              },
            }, '查看') : '',
            this.handlePermission('workflowEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'workflowEdit',
                    params: {
                      id: row.code,
                    },
                  });
                },
              },
            }, '编辑') : '',
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    getBizTypeList() {
      workflow.bussinessTypes().then((res) => {
        if (res.data.status === 200) {
          this.bizTypeList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleReset() {
      this.query = {};
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;

      workflow.getWorkflowList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.tableData = [];
          list.forEach((workflowItem) => {
            const item = workflowItem.workPermission;
            item.bizTypeNameListStr = workflowItem.bizTypeNameList.join('、');
            item.statusStr = this.statusMap.get(item.status); // 状态
            item.versionStr = `v${item.version.toFixed(1)}`;
            const storeIdNameList = [];
            // 适用门店名称
            workflowItem.sysStoreList.forEach((store) => {
              storeIdNameList.push(store.name);
            });
            item.storeIdNameListStr = storeIdNameList.join(';');
            item.createTimeStr = utils.formatTime(item.createTime) || '-'; // 创建时间
            item.lastEnableTimeStr = utils.formatTime(item.lastEnableTime) || '-'; // 最后启用时间
            this.tableData.push(item);
          });
          this.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNew() {
      this.$router.push({ name: 'workflowAdd' });
    },
  },
  created() {
    this.getBizTypeList();
    this.handleSearch(true);

    // 没有编辑权限，移除操作列
    if (!this.hasAction) {
      this.columns.pop();
    }
  },
};
</script>
<style lang="less" scoped>
</style>
